<template>
  <div class="fabric-spec-container">
    <div>
      <div class="spec-img__wrapper d-flex">
        <div
          class="d-flex justify-content-start align-items-center div_border b-b1"
          style="min-width:230px"
        >
          <div class="checkbox__wrapper mr-3">
            <el-checkbox v-model="checked" @change="checkSpec"></el-checkbox>
          </div>
          <div class="div_no" :title="specInfo.specNo">
            NO: {{ specInfo.specNo || '' }}
          </div>
        </div>

        <div
          class="d-flex justify-content-between align-items-center"
          style="width:100%"
        >
          <div class="div_title ml-4">
            {{ $l('INDEX.evg_sku_label_fabric_composition') || '面料构成' }}
          </div>
          <div class="div_title" v-if="!disabled">
            <el-button class="mr-2 radius" @click="addFabric" size="mini">{{
              $l('INDEX.evg_sku_label_edit_fabric') || '编辑面料'
            }}</el-button>
          </div>
        </div>
      </div>
      <div class="d-flex b-b1">
        <div
          style="width:230px;min-width:230px"
          class="d-flex justify-content-center div_border"
        >
          <div class="spec-img">
            <div class="div_box">
              <el-image
                :src="
                  specInfo.defaultImageUrl
                    ? $osscdn(specInfo.defaultImageUrl)
                    : '/image/static/img/nopic-square.jpg'
                "
                :preview-src-list="[
                  specInfo.defaultImageUrl
                    ? $osscdn(specInfo.defaultImageUrl)
                    : '/image/static/img/nopic-square.jpg',
                ]"
              >
                <div slot="error" class="image-slot">
                  <img src="/image/static/img/nopic-square.jpg" />
                </div>
              </el-image>
            </div>
            <div class="title_box mt-2">
              <div class="spec_title ">
                <div class="weight_8 mt-1">
                  {{ specInfo.specName || '' }}
                </div>
                <div class="mt-1">
                  {{ specInfo.specNameEn || '' }}
                </div>
                <div class="weight_8 mt-2">SIZE</div>
                <div>
                  {{ specInfo.v_goodsSize || '' }}
                </div>
                <div class="weight_8 mt-1">QTY</div>
                <div class="weight_8">
                  {{ specInfo.specQty || '' }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div :class="{ spec_card: true, fabric_back: !isEmpty }">
          <FabricInfo
            v-if="!isEmpty"
            :fabricList="fabricList"
            :disabled="disabled"
            @delFabric="delFabric"
            @updateFabric="updateFabric"
          ></FabricInfo>
          <div v-if="isEmpty" class="no-data__wrapper">
            <div class="child">
              <img src="/image/static/img/nodata.png" />
              <p class="no-data">
                {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="d-flex justify-content-between align-items-center"
        style="width:100%;"
      >
        <div class="foot_title">
          Modify by：{{ specInfo.modifyByName || '--' }} at
          {{ specInfo.modifyDate || '--' }}
        </div>
      </div>
    </div>

    <AddFabric
      :visible.sync="addFabricVisible"
      @chooseFabric="chooseFabric"
    ></AddFabric>
  </div>
</template>
<script>
import FabricInfo from '../fabric-info'
import AddFabric from '../add-fabric'
import EditLoading from '@/mixins/edit-loading'
export default {
  props: {
    disabled: { type: Boolean, default: true },
    evgSkuCode: { type: String, default: '' },
    specInfo: { type: Object, default: () => {} },
  },
  mixins: [EditLoading],
  components: { FabricInfo, AddFabric },
  data() {
    return {
      fabricData: {},
      checked: false,
      addFabricVisible: false,
      fabricList: [],
    }
  },
  computed: {
    isEmpty() {
      return !this.fabricList.length
    },
    evgSkuSpecCode() {
      return this.specInfo.evgSkuSpecCode
    },
  },
  mounted() {
    this.initFabric()
  },
  methods: {
    initFabric() {
      if (this.evgSkuSpecCode) {
        this.$api
          .ecomEvgSkuSpecFabricListApi({
            evgSkuSpecCode: this.evgSkuSpecCode,
          })
          .then((res) => {
            this.fabricList = res.body.data
          })
      }
      this.checked = false
    },
    addFabric() {
      // this.addFabricVisible = true
      this.$emit('addFabric', this.evgSkuSpecCode)
    },
    chooseFabric(fabric) {
      this.fabricList.push({ ...fabric, id: new Date().getTime() })
      this.addFabricVisible = false
    },
    updateFabric(index, fabric) {
      this.fabricList.splice(index, 1, { ...fabric })
    },
    delFabric(index) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        const { evgSkuSpecFabricCode } = this.fabricList[index]
        if (evgSkuSpecFabricCode) {
          this.$api
            .ecomEvgSkuSpecFabricDelApi({
              evgSkuSpecFabricCode,
            })
            .then(() => {
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
                type: 'success',
              })
              this.fabricList.splice(index, 1)
              this.loadingClose()
            })
            .catch(() => {
              this.loadingClose()
            })
        } else {
          this.fabricList.splice(index, 1)
          this.loadingClose()
        }
      })
    },
    checkSpec(c) {
      if (c) {
        this.$emit('checkSpec', this.specInfo)
      } else {
        this.$emit('delCheck', this.specInfo)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.fabric-spec-container {
  border: 1px solid #efefef;
  margin-bottom: 10px;
}
.no-data__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  .child {
    width: fit-content;
    height: fit-content;
  }
  .no-data {
    text-align: center;
  }
}
.checkbox__wrapper {
  margin: 0px 8px;
  display: flex;
  align-items: center;
}
.spec-img__wrapper {
  height: 41px;
  background-color: #fafafa;

  .div_no {
    line-height: 43px;
    font-weight: 600;
    color: #4f4f4f;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .div_title {
    line-height: 43px;
    font-weight: 600;
    color: #2b3447;
    font-size: 14px;
  }
}
.fabric_back {
  background-color: #efefef;
}
.spec-img {
  margin-top: 11px;
  text-align: center;
  .div_box {
    width: 150px;
    height: 150px;
    border: 1px dashed #cecece;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    .el-image {
      border-radius: 5px;
      width: 140px;
      height: 140px;
    }
  }

  .title_box {
    width: 150px;
    max-height: 240px;
    height: 240px;
    overflow-y: auto;
    color: #4f4f4f;
    word-wrap: break-word;

    &::-webkit-scrollbar {
      width: 2px;
    }
    &::-webkit-scrollbar-track {
      background: rgb(239, 239, 239);
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb {
      background: #bfbfbf;
      border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #333;
    }
    &::-webkit-scrollbar-corner {
      background: #179a16;
    }
  }
}
.radius {
  border-radius: 5px !important;
}
.weight_8 {
  font-weight: 800;
}
.spec_card {
  width: 100%;
  height: 410px;
  overflow-y: auto;
}
.div_border {
  border-right: 1px solid #efefef;
}
.spec_title {
  font-size: 14px;
  text-align: left;
}
.b-b1 {
  border-bottom: 1px solid #efefef;
}
.p-10 {
  padding: 5px 10px;
}
.w-full {
  width: 100%;
}
.fabric-info-container {
  padding: 0px 10px 10px 10px;
}
.foot_title {
  color: #8e8e8e;
  font-size: 14px;
  line-height: 43px;
  margin-left: 40px;
}
</style>
